import { uploadFiles as directusUpload } from '@directus/sdk'
interface FileUpload {
  file: File
  folder?: string
  name: string
}

export type ThumbnailFormat = 'jpg' | 'png' | 'tiff' | 'webp'
export type ThumbnailFit = 'contain' | 'cover' | 'inside' | 'outside'
export interface ThumbnailOptions {
  fit?: ThumbnailFit
  format?: ThumbnailFormat
  height?: number
  quality?: number
  width?: number
  withoutEnlargement?: boolean
}

export default function useDirectusFiles() {
  const config = useRuntimeConfig()
  const { $directus } = useNuxtApp()
  const { request } = useDirectusRest()
  const uploadFiles = async (files: FileUpload | FileUpload[]) => {
    if (!Array.isArray(files)) files = [files]
    const formData = new FormData()
    for (const file of files) {
      formData.append('title', file.name) // Add the file name to the form data
      if (file.folder) formData.append('folder', file.folder) // Add the folder name to the form data if it exists
      formData.append('file', file.file) // Add the file to the form data
    }
    return await request(directusUpload(formData))
  }

  const getThumbnail = (fileId: string, options?: ThumbnailOptions): string => {
    const url = new URL(`${config.public.directusUrl}assets/${fileId}`)
    if (options) {
      for (const [key, value] of Object.entries(options)) {
        url.searchParams.append(key, value.toString())
      }
    }
    return url.href
  }

  return {
    getThumbnail,
    uploadFiles,
  }
}
